import { injectable } from 'inversify';
import type {
  AbstractCockpitApiErrorDataTransformer,
  CockpitApiErrorContext,
} from '@shared/common/error/data/transformer/abstract-cockpit-error.api-data-transformer';
import type { CockpitErrorResponseApiData } from '@shared/common/error/data/api-data/cockpit-error-response.api-data';
import { UnknownError } from '@shared/common/error/domain/error/unknown.error';

@injectable()
export class UnknownApiErrorDataTransformer implements AbstractCockpitApiErrorDataTransformer {
  public map(data: CockpitErrorResponseApiData, context: CockpitApiErrorContext): UnknownError {
    const responseMessage = data.message?.trim();
    const userMessage = responseMessage || 'common.unexpected-error';
    const diagnosticParts = [`Cockpit API request failed with HTTP ${context.status}.`];

    if (data.code) {
      diagnosticParts.push(`API error code: ${data.code}.`);
    }

    diagnosticParts.push(
      responseMessage
        ? `API response message: ${responseMessage}`
        : 'The API response did not provide an error message.',
    );

    return new UnknownError(userMessage, data.code, diagnosticParts.join(' '), context.cause);
  }
}
